import { getFrontendUrl } from "../utils";
import { Post } from "../../types/Post";
import { getImageUrl } from "../getImageUrl";
import { getAboutRichSnippet } from "./about";
import { getOrganisationRichSnippet } from "./organisation";

export function getBlogPostRichSnippet(post: Post) {
  const personSchema = getAboutRichSnippet();
  const orgSchema = getOrganisationRichSnippet();

  const richData: Record<string, unknown> = {
    "@type": "BlogPosting",
    "@id": getFrontendUrl(`/#blog/${post.slug}`),
    headline: post.name,
    url: getFrontendUrl(`/blog/${post.slug}`),
    datePublished: post.created,
    dateModified: post.updated,
    articleSection:
      (post.tags || []).length > 0
        ? post.tags.map((tag) => tag.name).join(", ")
        : "Blog",
    author: {
      "@id": personSchema["@id"],
      "@type": "Person",
      name: personSchema.name,
      url: getFrontendUrl("/about-drew"),
    },
    publisher: {
      "@id": orgSchema["@id"],
      "@type": "Organization",
      name: orgSchema.name,
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": getFrontendUrl(`/blog/${post.slug}`),
    },
  };

  if (getImageUrl(post.featured_image)) {
    richData.image = getImageUrl(post.featured_image);
  }

  if (post.description) {
    richData.description = post.description;
  }

  return richData;
}
